import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import MobileHeader from "../../../components/MobileHeader";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
export default function PublishSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const type = location.state?.type || "publication";
  const date = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  return (
    <div className="min-h-screen bg-gray-50">
  <div className="min-h-[90vh]">
    {isMobile ? (
      <MobileHeader hideFilter={true} />
    ) : (
      <Header hideFilter={true} />
    )}

    <div className="flex flex-col items-center justify-center pt-32 px-4">
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-[#e8f0f7] rounded-2xl flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-2xl font-semibold text-gray-900">Your {type}</h2>
      </div>

      <div className="bg-white rounded-2xl p-10 text-center max-w-2xl w-full shadow-sm border border-gray-200">
        <div className="mb-8">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-4">
            Successfully added your {type}
          </h3>
          <span className="inline-block px-4 py-2 rounded-full bg-[#e8f0f7] text-[#0f6abf] text-sm font-medium">
            Added on {date}
          </span>
        </div>

        <div className="flex justify-center gap-4">
          <button
            onClick={() => navigate("/home")}
            className="px-6 py-3 text-sm font-medium rounded-xl bg-[#0f6abf] text-white hover:bg-[#0a5ca8] transition-colors"
          >
            View {type}
          </button>

          <button
            onClick={() => navigate("/publish/journal")}
            className="px-6 py-3 text-sm font-medium rounded-xl border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Add more research
          </button>
        </div>
      </div>
    </div>
  </div>

  <Footer />
</div>
  );
}
